import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';

import { Box, Button, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import StreetviewIcon from '@mui/icons-material/Streetview';
import Loading from '../Loading';
import useTimeStore from '../ZustandProvider';
import OpenModalFromUrl from '../OpenModalFromUrl';

const CatastroComponent = ({ MapProps }) => {
  const coordOnMap = useTimeStore(state => state.coordOnMap);

  const { connector, server } = MapProps.map.settingsAdvancedMap.downloadLinks;
  const { catastroSettings } = MapProps.map.settingsAdvancedMap;

  const streetTypeView =
    (catastroSettings && catastroSettings.streetTypeView && catastroSettings.streetTypeView) ||
    'window';

  const [informationSettings, setInformationSettings] = React.useState('');
  const viewInformationInitial =
    (catastroSettings && catastroSettings.viewInformation && catastroSettings.viewInformation) ||
    false;
  const [openInfo, setOpenInfo] = React.useState(viewInformationInitial);
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentLocation, setCurrentLocation] = React.useState({});
  const [openStreetView, setOpenStreetView] = React.useState(false);

  const urlCall = () => {
    let url;
    if (server.serverType === 'IGP') {
      url = `http://${server.ip}:${server.port}/MG/lidar/exec_filter_lidar`;
    } else if (server.serverType === 'IGPS' || server.serverType === 'input') {
      url = `${server.domain}/MG/lidar/exec_filter_lidar`;
    }
    return url;
  };

  const dataBase = {
    host: connector.ip,
    port: connector.port,
    database: connector.databaseName,
    user: connector.user,
    password: connector.password,
    esquema: connector.schema,
    tabla: 'configuration'
  };

  const callToBack = async () => {
    try {
      const infoUser = {
        currentLocation,
        mapId: MapProps.map._id,
        mapName: MapProps.map.name,
        userId: MapProps.map.owner,
        time: `${`${new Date().getDate()}-${new Date().getMonth() +
          1}-${new Date().getFullYear()}` +
          ' '}${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
      };
      if (!isEmpty(coordOnMap)) {
        const response = await fetch(urlCall(), {
          method: 'POST',
          body: JSON.stringify({
            coordSystem: 'EPSG:4326',
            dataBase,
            inputFile: '',
            mongo: [],
            point: [coordOnMap.lat, coordOnMap.lng],
            user: infoUser,
            tableId: '',
            tableFilter: '',
            typeGeometry: 'catastro',
            typeFile: []
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });
        const respuesta = await response.json();
        setInformationSettings(respuesta);
        setIsLoading(false);
      } else {
        Bert.alert('Selecciona un punto en el mapa o introdúzcalo', 'warning');
        setIsLoading(false);
      }
    } catch (error) {
      Bert.alert('No se encuentran datos', 'danger');
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    setIsLoading(true);
    navigator.geolocation.getCurrentPosition(position => {
      const coordinates = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      };
      setCurrentLocation(coordinates);
    });
    callToBack();
  }, [coordOnMap]);

  return (
    <>
      <Box
        sx={{
          overflow: 'hidden',
          m: '2%',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%'
        }}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <Box sx={{ height: '100%' }}>
            {isEmpty(informationSettings) && (
              <Typography variant="h6" fontWeight="bold" m={1}>
                Selecciona un punto
              </Typography>
            )}
            {informationSettings && informationSettings.information && (
              <>
                {!isEmpty(informationSettings.information) && (
                  <>
                    <Box
                      sx={{
                        flex: '1 1 auto',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        mb: 2
                      }}
                    >
                      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Typography variant="h6" fontWeight="bold" m={1}>
                          {informationSettings.name}
                        </Typography>
                        <Button
                          aria-label="Configuración"
                          onClick={() => {
                            setOpenInfo(!openInfo);
                          }}
                          sx={{ color: '#2A3F90', mb: 2 }}
                          size="small"
                        >
                          {openInfo ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          Información
                        </Button>
                      </Box>
                      <Typography variant="body2" fontWeight="bold" m={1}>
                        {informationSettings.information}
                      </Typography>
                      {streetTypeView && streetTypeView === 'inside' && (
                        <Box sx={{ flex: '0 1 300px', width: '100%', height: '300px', mb: 1 }}>
                          <iframe
                            title="WebPage"
                            src={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCgXcfztuA0NG4n_pXFYyEmdLZNWIdEHAo&location=${coordOnMap.lat},${coordOnMap.lng}&heading=210&pitch=10&fov=35`}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                          />
                        </Box>
                      )}
                      {openInfo && (
                        <Box sx={{ flex: '1 1 500px', overflow: 'hidden', height: '500px', mb: 2 }}>
                          <iframe
                            src={`https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?rc1=${informationSettings.name.slice(
                              0,
                              7
                            )}&rc2=${informationSettings.name.slice(7)}`}
                            style={{ border: 'none', width: '100%', height: '100%' }}
                            title="ViewLinks"
                          />
                        </Box>
                      )}
                      {streetTypeView && streetTypeView === 'window' && (
                        <Button
                          aria-label="window"
                          onClick={() => {
                            window.open(
                              `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${coordOnMap.lat},${coordOnMap.lng}`,
                              '_blank'
                            );
                          }}
                          sx={{ color: '#2A3F90' }}
                          size="small"
                        >
                          <StreetviewIcon />
                        </Button>
                      )}
                      {streetTypeView && streetTypeView === 'modal' && (
                        <Button
                          aria-label="modal"
                          onClick={() => {
                            setOpenStreetView(!openStreetView);
                          }}
                          sx={{ color: '#2A3F90' }}
                          size="small"
                        >
                          <StreetviewIcon />
                        </Button>
                      )}
                    </Box>
                  </>
                )}
              </>
            )}
          </Box>
        )}
      </Box>

      <OpenModalFromUrl
        isFullScreen
        openModal={openStreetView}
        setOpenModal={setOpenStreetView}
        title={!isEmpty(informationSettings) ? informationSettings.name : ''}
        url={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCgXcfztuA0NG4n_pXFYyEmdLZNWIdEHAo&location=${coordOnMap.lat},${coordOnMap.lng}&heading=210&pitch=10&fov=35`}
      />
    </>
  );
};

CatastroComponent.defaultProps = {
  MapProps: {}
};

CatastroComponent.propTypes = {
  MapProps: PropTypes.object
};

export default CatastroComponent;
